var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.83643C2 6.17957 3.34315 4.83643 5 4.83643H19C20.6569 4.83643 22 6.17957 22 7.83643V17.8364C22 19.4933 20.6569 20.8364 19 20.8364H5C3.34315 20.8364 2 19.4933 2 17.8364V7.83643ZM4.11209 7.37597L11.4453 12.2648C11.7812 12.4887 12.2188 12.4887 12.5547 12.2648L19.8879 7.37597C19.7213 7.0554 19.3862 6.83643 19 6.83643H5C4.61376 6.83643 4.27867 7.0554 4.11209 7.37597ZM20 9.70494L13.6641 13.9289C12.6564 14.6007 11.3436 14.6007 10.3359 13.9289L4 9.70494V17.8364C4 18.3887 4.44772 18.8364 5 18.8364H19C19.5523 18.8364 20 18.3887 20 17.8364V9.70494Z",
    fill: "var(--grey-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5efbe3cfe3687f0f7109e3776bfe8945.svg";
export { ForwardRef as ReactComponent };